export const ROUTER_PATHS = {
  MAIN: '/:shortId',
};
